import React, { FC } from 'react';

import { PaymentType, Transaction as TransactionModel, translateAccountType } from 'api-client';
import { CustomLink, DataTable, Money } from 'components/common';
import { MoneyMode } from 'components/common/utils/Money/Money';
import { formatDate } from 'formatters';
import { useTransactionsTranslation } from 'hooks/useTransactionsTranslation';
import { cn, RouteDictionary } from 'utils';

import styles from './TransactionTableRow.module.scss';

interface Props {
  transaction: TransactionModel;
}

const TransactionTableRow: FC<Props> = ({ transaction }) => {
  const translateTransaction = useTransactionsTranslation();
  const isIncome = transaction.paymentType !== PaymentType.DEBIT;

  return (
    <DataTable.Row className={styles.row}>
      <DataTable.Cell>
        {transaction.projectName === undefined ? (
          <div className={styles.projectName}>Проект не указан</div>
        ) : (
          <CustomLink
            to={RouteDictionary.DETAILED_PROJECT}
            params={{ uuid: transaction.projectUuid }}
            className={styles.projectLink}
          >
            <div className={styles.projectName}>{transaction.projectName[0].text}</div>
          </CustomLink>
        )}
      </DataTable.Cell>
      <DataTable.Cell className={styles.nowrap}>{formatDate(transaction.date)}</DataTable.Cell>
      <DataTable.Cell className={cn(styles.nowrap, isIncome && styles.income)}>
        <span>{isIncome ? '+' : '-'}</span>
        <Money money={transaction.money} mode={isIncome ? MoneyMode.WRITE_OFF : undefined} />
      </DataTable.Cell>
      <DataTable.Cell>{translateTransaction(transaction.transactionType).text}</DataTable.Cell>
      <DataTable.Cell>{translateAccountType(transaction.accountType)}</DataTable.Cell>
      <DataTable.Cell className={styles.description}>
        {translateTransaction(transaction.transactionType).description}
      </DataTable.Cell>
    </DataTable.Row>
  );
};

export default TransactionTableRow;
